import styled from 'styled-components';
import {device} from '@guestapp/ui/src/utils/device';
import {Button} from '@guestapp/ui';

export const Wrapper = styled.div`
  width: 100%;

  & .checkbox__label {
    font-weight: 400;
  }

  & .computed-box {
    max-width: 295px;
  }
  & .fields-group-title {
    color: ${({theme}) => theme.colors.branding.fontSecondary};
  }

  */ & .sign-block__checkbox-container,
  & .sign-block__warning {
    margin-bottom: 24px;
  }
`;

export const StyledButton = styled(Button)`
  width: 100%;

  @media (min-width: ${device.tablet}) {
    max-width: 327px;
    margin: 0 auto;
  }
`;
